import { CONFIRM_DECLINED_CONTACT, DECLINED_CONTACTS } from '@mm/api-routes';
import Controller from './Controller';

export type DeclinedContactsResponse = {
  success: boolean;
  errors?: string[];
  error_code?: string;
};

export default class DeclinedContactsController extends Controller {
  static async postDeclinedContact(
    email: string,
    captchaToken: string,
    zipCode?: string,
  ): Promise<DeclinedContactsResponse> {
    return super.post(DECLINED_CONTACTS, {
      email,
      captchaToken,
      zipCode,
    });
  }

  static async confirmDeclinedContact(
    email: string,
    token: string,
  ): Promise<DeclinedContactsResponse> {
    return super.post(CONFIRM_DECLINED_CONTACT, {
      email,
      token,
    });
  }
}
